module.exports = __webpack_public_path__ + "img/bg7.1a4db11c.png";